import type { Rating } from "@/domain/rating";
import { apiClient } from "../apiClient";

export const getJourneyRating = (journeyId: number): Promise<Rating> => {
  return apiClient
    .get(`/journey-service/dashboard/journeys/${journeyId}/rating`)
    .then((r) => r.data);
};
